<template>
    <div class="event-member-actions">
        <EventSaveButton :event-id="event.id" />

        <BaseButton
            v-if="
                loggedIn &&
                    event.isFullyBooked &&
                    isInWaitingList &&
                    !hasReservation
            "
            class="button--secondary"
            @click="openReservationModal"
        >
            Op wachtlijst
            <template #after>
                <BaseIcon icon="check" />
            </template>
        </BaseButton>

        <BaseButton
            v-else-if="(!loggedIn || !hasReservation) || event.isCancelled"
            :disabled="!!disabled"
            class="button--secondary"
            @click="openReservationModal"
        >
            {{ reserveText }}

            <template
                v-if="showButtonIcon"
                #after
            >
                <BaseIcon icon="arrow-right" />
            </template>
        </BaseButton>

        <BaseButton
            v-else-if="loggedIn && hasReservation"
            class="button--secondary"
            @click="openReservationModal"
        >
            Gereserveerd
            <template #after>
                <BaseIcon icon="check" />
            </template>
        </BaseButton>
    </div>
</template>

<script setup lang="ts">
import * as RESERVATION_TYPES from '~/constants/reservationTypes.js';

const props = defineProps<{
    event: EventDate;
}>();

const { event } = toRefs(props);

const { loggedIn } = storeToRefs(useUserStore());

const userStore = useUserStore();
const modalStore = useModalStore();

const isInWaitingList= computed(() => userStore.isInWaitingList(props.event.id));

const hasReservation = computed(() => userStore.hasReservation(props.event.id));

const isWapresFullyBooked = computed(() => {
    return props.event.reservationType === RESERVATION_TYPES.WAPRES
        && props.event.isFullyBooked
        && !props.event.doorsaleEnabled;
});

const reservationState = computed(() => {
    if (props.event.isCancelled) {
        return 'cancelled';
    }

    if (props.event.isSoldout) {
        return 'sold-out';
    }

    if (isWapresFullyBooked.value && !isInWaitingList.value && props.event.waitingListEnabled) {
        return 'waiting-list';
    }

    if (isWapresFullyBooked.value) {
        return 'fully-booked';
    }

    if (!props.event.isActive) {
        return 'inactive';
    }

    return 'default';
});

const reserveText = computed(() => {
    if (reservationState.value === 'cancelled') {
        return 'Dit programma is afgelast';
    }

    if (reservationState.value === 'sold-out') {
        return 'Dit programma is uitverkocht';
    }

    if (reservationState.value === 'fully-booked') {
        return 'Volgereserveerd';
    }

    if (reservationState.value === 'inactive') {
        return 'Dit programma is al geweest';
    }

    return 'Ticket reserveren';
});

const showButtonIcon = computed(() => {
    if (reservationState.value !== 'default') {
        return false;
    }

    return true;
});

const disabled = computed(() => {
    const disabledStates = [
        'sold-out',
        'fully-booked',
        'inactive',
        'cancelled'
    ];

    return disabledStates.includes(reservationState.value);
});

const openReservationModal = () => {
    modalStore.open(MODAL_RESERVATION);
};
</script>

<style lang="less" src="./EventMemberActions.less" />
